/**
 * `88520` — *create a {board, boardMapping} from template*.
 *
 * One production node (recipe 127241238, "when button clicked create a board from template").
 * The slot is monday's board-creation form, verbatim:
 * `{boardKind, templateId, boardName, folderId, workspaceId, boardOwners, boardOwnerTeams,
 * boardSubscribers, boardTeamsSubscribers}` — and `boardName` carries text tokens
 * (`"PRJ-{pulse.name}"` in the real config), so the name is interpolated like any message.
 *
 * `workspaceId: -1` is monday's "main workspace" sentinel in that config; it is passed through
 * as `null`, which is what our board service reads as "the board's own workspace".
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { boardMappingSchema } from '../item-mapping.js';
import { interpolateTokens } from '../tokens.js';
import { tokenContextFor } from './token-context.js';
export const createBoardFromTemplateParams = z.object({
    boardMapping: boardMappingSchema,
});
const idOrNull = (value) => value === null || value === undefined || Number(value) < 0 ? null : String(value);
export const createBoardFromTemplateAction = defineAction({
    id: '88520',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'create a {board, boardMapping} from template',
    paramsSchema: createBoardFromTemplateParams,
    executable: true,
    references: (params) => params.boardMapping.boardOwners.map((id) => ({ kind: 'user', id: String(id) })),
    async execute(context, params) {
        const create = context.services.createBoardFromTemplate;
        if (create === undefined)
            return { skipped: 'unsupported' };
        const mapping = params.boardMapping;
        const tokens = await tokenContextFor(context, [mapping.boardName]);
        const name = interpolateTokens(mapping.boardName, tokens);
        const created = await create({
            templateId: idOrNull(mapping.templateId),
            name: name.length === 0 ? 'New board' : name,
            workspaceId: idOrNull(mapping.workspaceId),
            folderId: idOrNull(mapping.folderId),
            boardKind: mapping.boardKind,
            ownerIds: mapping.boardOwners.map(String),
            subscriberIds: mapping.boardSubscribers.map(String),
        });
        return { boardId: created.boardId, name };
    },
});
//# sourceMappingURL=88520.js.map